import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'antd'
import { renderTextStr } from '@/utils/renderUtils'
import { TUINA_PAY_METHOD_OPTIONS } from '@/views/tuina/options'

const FormItem = Form.Item

class PurchasePayForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    orderNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    payMethod: PropTypes.string
  }

  render () {
    const { form, orderNo, payMethod } = this.props
    const row = TUINA_PAY_METHOD_OPTIONS.find((item) => item.id === payMethod)
    const payMethodText = (row && row.value) || payMethod
    return (
      <Form ref={form} layout="vertical">
        <p>{payMethodText ? `请确认客户已完成${payMethodText}支付。` : '请确认客户已完成支付。'}</p>
        <FormItem label="订单号">
          <span>{renderTextStr(orderNo)}</span>
        </FormItem>
        <FormItem label="支付方式">
          <span>{renderTextStr(payMethodText)}</span>
        </FormItem>
      </Form>
    )
  }
}

export default PurchasePayForm
